import { HttpErrorResponse } from '@angular/common/http';
import { createActionGroup, props } from '@ngrx/store';
import { PaymentPreviewHostedPaymentV1Response } from '@arc/unified-payments-frontend/shared-payment';

export const HostedPaymentsPadResultComponentPaymentPreviewActions =
  createActionGroup({
    source: 'Pad Result Component Payment Preview',
    events: {
      'Load Payment Preview Success': props<{
        response: PaymentPreviewHostedPaymentV1Response;
      }>(),
      'Load Payment Preview Error': props<{ error: HttpErrorResponse }>(),
    },
  });
